import React from "react";
import { useState } from "react";
import "../../style/portfolio.css";
import feedbackDesktop from "../../images/feedbackDesktop.jpg";
import feedbackMobile from "../../images/feedbackMobile.jpg";

const Feedback = () => {
  const [desktop, setDesktop] = useState(true);
  const desktopImg = () => {
    setDesktop(true);
  };
  const mobileImg = () => {
    setDesktop(false);
  };

  return (
    <div className="portfolio-element">
      <div className="portfolio-right">
        <h1 className="headings-portfolio">Feedback App</h1>
        <p>
          Este proyecto ha sido un desafío de Frontend Mentor, una plataforma en
          la que me permite practicar la creación de sitios web junto con el
          diseño. Este proyecto incluye el diseño móvil y el diseño web con sus
          diferentes tamaños de pantalla, permitiendo a cada usuario iniciar
          sesión, crear comentarios y editarlos. Se ha utilizado React Context
          para compartir propiedades entre componentes.
        </p>
        <a target="blank" href="https://feedback-reviews.netlify.app/">
          <button className="btn-visitar">Ver proyecto</button>
        </a>
        <a target="blank" href="https://github.com/khanchandanivikas/feedback">
          <button className="btn-visitar">Ver codigo</button>
        </a>
      </div>
      <div className="portfolio-left">
        <img src={desktop ? feedbackDesktop : feedbackMobile} alt="CRUD App" />
        <br />
        <button
          className={desktop ? "btn-active" : "btn-inactive"}
          onClick={desktopImg}
        >
          DISEÑO DESKTOP
        </button>
        <button
          className={desktop ? "btn-inactive" : "btn-active"}
          onClick={mobileImg}
        >
          DISEÑO MOVIL
        </button>
      </div>
    </div>
  );
};

export default Feedback;
